import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5 mt-5">
      <div className="container">
        <div className="row pb-4">
          <div className="col-lg-4 col-md-6 mb-4">
            <h3 className="h4 fw-semibold mb-3">KLV Diagnostic</h3>
            <p className="text-light mb-0" style={{ lineHeight: '1.6' }}>
              Trusted diagnostic laboratory offering high-quality testing services with modern technology and expert staff.
            </p>
          </div>
          
          <div className="col-lg-4 col-md-6 mb-4">
            <h4 className="h5 mb-3">Quick Links</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#" className="text-light text-decoration-none">Home</a>
              </li>
              <li className="mb-2">
                <a href="#" className="text-light text-decoration-none">Our Services</a>
              </li>
              <li className="mb-2">
                <a href="#" className="text-light text-decoration-none">Book a Test</a>
              </li>
              <li className="mb-2">
                <a href="#" className="text-light text-decoration-none">Contact</a>
              </li>
            </ul>
          </div>
          
          <div className="col-lg-4 col-md-12 mb-4">
            <h4 className="h5 mb-3">Contact Us</h4>
            <p className="text-light mb-2">1117/170, Sharda Nagar Rd, Namak Factory Chauraha, Chhapeda Pulia, crossing, Sharda Nagar, Kanpur, Uttar Pradesh 208025</p>
            <p className="text-light mb-2">Phone: +91 091152 23372</p>
            <p className="text-light mb-0">Email: info@klvdiagnostic.com</p>
          </div>
        </div>
      </div>
      
      <div className="border-top border-secondary text-center py-3" style={{ backgroundColor: '#181a1f' }}>
        <div className="container">
          <p className="text-muted mb-0">
            © {new Date().getFullYear()} KLV Diagnostic. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;